import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
//import { SolrSchema, FieldType, FieldFlags, QueryNodeCompareType } from "../../3x1010/Solr.js";
import * as Solr from "../../3x1010/Solr.js";

export default class PageSolrOneField extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrOneField - Hello world");

    //let s = new Solr();
    //s.hello();

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
    //
    // solr quqry
    this.collectionName = "FOTOTECA_coll";
    this.schema = null;
    this.lastRq = null;
    this.fields = [];
    // campi
    this.initFields();
    //
    $(".wlfInfo").text(this.collectionName);
    $(".wlfSearch").on("click", this.onSearch.bind(this, false));
    $("body").keydown(this.onSearch.bind(this, true));
    $(".wlfPrev").on("click", this.onMove.bind(this, -1));
    $(".wlfNext").on("click", this.onMove.bind(this, +1));
  }

  get isHomepage() {
    return true;
  }

  // ***********************************

  initFields() {
    this.schema = new Solr.Schema(this.collectionName);
    //var sel = $(".wlfField");
    this.fields = this.schema.getAllFields(Solr.FieldFlags.FLAG_QUERY, 1, false);
    console.log(this.fields);
    //
    var sel = $(".wlfField");
    for (let f of this.fields) {
      var opt = $("<option></option>");
      opt.val(f._path);
      opt.text(f._label);
      sel.append(opt);
    }
    sel.on("change", this.onFieldChange.bind(this));
  }

  onFieldChange() {
    let _path = $(".wlfField").val();
    if (_path == "") {
      $("#wlfDivHide").hide();
      return;
    }
    $("#wlfDivHide").show();
    $(".wlfInputText").val("");
    // carico gli operatori
    let sel = $(".wlfMode");
    sel.find("option").remove().end();
    // becco lista di operatori
    var field = this.fields.find((f) => f._path == _path);
    let operators = Solr.Schema.getOperatorsForType(field.Type, field.Lookup ? true : false);
    // se ho provider (bisognrenne poi limitare gli operatori)
    if (field.Lookup) {
      $(".wlfInputText").attr("list", "wlfInputTextDataList");
      //
      let selProv = $("#wlfInputTextDataList");
      for (let l of SolrLOOKUPS[field.Lookup].Rows) {
        var opt = $("<option></option>");
        opt.val(l.Value);
        opt.text(l.Label);
        selProv.append(opt);
      }
    } else {
      $(".wlfInputText").removeAttr("list");
    }
    //
    for (let o of operators) {
      var opt = $("<option></option>");
      opt.val(o);
      opt.text(o);
      sel.append(opt);
    }
    sel.off("change");
    sel.on("change", this.onOperatorChange.bind(this));
    this.onOperatorChange();
  }

  onOperatorChange() {
    let op = $(".wlfMode").val();
    // se unario nascondo input
    let numArs = Solr.QueryNodeCompareType.getNumArgs(op);
    if (numArs <= 0) $(".wlfInputText").hide();
    else $(".wlfInputText").show();
  }

  // ***********************************

  onMove(dir) {
    if (this.lastRq == null) return;
    //
    var pageSize = this.lastRq.options.RowsNum;
    var maxStart = Math.max(0, Math.ceil(this.lastRq.TotalRows / pageSize) - 1) * pageSize;
    var rqStart = this.lastRq.options.RowStart + dir * pageSize;

    if (rqStart < 0 || rqStart > maxStart) return;
    //
    this.lastRq.options.RowStart = rqStart;
    var rq = this.lastRq;
    //
    this.showPreloader(true);
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onSearch(key, e) {
    //e.preventDefault();
    if (key) {
      if (!(e.which == 13)) return;
    }
    var $search = $(".wlfInputText").val(); // DEVE ESSERE FORMATTO IN MODO CORRETTO IN BASE AL TIPO DI CAMPO
    var $field = $(".wlfField").val();
    var $compare = $(".wlfMode").val();
    // console.log("onSearch", $search);
    //this.search($search);
    var rq = {
      action: "onefield",
      collectionName: this.collectionName,
      query: {
        FieldPath: $field,
        Value: $search,
        Compare: $compare,
        Occurency: $(".wlfNot").prop("checked") ? "NOT" : "MUST",
      },
      options: {
        IncludeChilds: true,
        IncludeRelations: 1,
        FilterRelations: null,
        RowStart: 0,
        RowsNum: 100,
        OrderBy: "id desc",
        Fields: "*",
      },
    };

    //debugger;
    this.lastRq = rq;
    this.showPreloader(true);
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onCallHandler(rs) {
    this.showPreloader(false);
    if (!rs.Success) {
      this.lastRq = null;
      //
      $(".wlfTotalRows").text();
      $(".wlfPageSize").text();
      $(".wlfPageRows").text();
      $(".wlfRowStart").text();
      $(".wlfRows").text("");
      //
      alert("Error");
      return;
    }
    // mi setto il total rows nella request (per il paging)
    this.lastRq.TotalRows = rs.TotalRows;
    //
    $(".wlfTotalRows").text(rs.TotalRows);
    $(".wlfPageSize").text(this.lastRq.options.RowsNum);
    $(".wlfPageRows").text(rs.Rows.length);
    $(".wlfRowStart").text(rs.RowStart);
    $(".wlfRows").text("");
    //
    var i = 0;
    for (var o of rs.Rows) {
      //var row = $("<texarea cols='300' rows='10' style='background-color:"+(i%2==0 ? "#EEEEEE" : "#FFFFFF")+"'></texarea>");
      var row = $("<span  style='background-color:" + (i % 2 == 0 ? "#EEEEEE" : "#FFFFFF") + "'></span>");
      var text = JSON.stringify(o /*, null, 2*/);
      row.text(rs.RowStart + i + "\t" + text);
      $(".wlfRows").append(row);
      $(".wlfRows").append("<br>");
      i++;
    }
  }
}
